import styled from 'styled-components'
// themes
import { colors } from 'themes/index'

export const ResponseSetContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 8px;
`

export const Label = styled('div')`
  display: flex;
  color: ${colors.gray300};
  font-size: 13px;
`
